import { BASE_URL } from '@/config'

export async function getCategories() {
  try {
    const response = await fetch(`${BASE_URL}/graphs/categorization/`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    })
    if (!response.ok) {
      const errorData = await response.json()
      throw new Error(errorData.message || 'Erro ao buscar categorias')
    }
    return await response.json()
  } catch (error) {
    console.error('Erro ao buscar categorias:', error)
    throw error
  }
}

export async function getCategoriesbyIdEnterprise(enterpriseId) {
  // console.log('ID da empresa getCategoriesbyIdEnterprise:', enterpriseId)
  try {
    const response = await fetch(
      `${BASE_URL}/graphs/categorization/${enterpriseId}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    if (!response.ok) {
      const errorData = await response.json()
      throw new Error(
        errorData.message || 'Erro ao buscar categorias da empresa'
      )
    }
    return await response.json()
  } catch (error) {
    console.error('Erro ao buscar categorias da empresa:', error)
    throw error
  }
}
